<template>
  
    <v-dialog v-model="show" 
    max-width="640">
      <v-alert 
        border="top"
        colored-border
        prominent
        type="warning">
        <p>
          <strong class="primary--text">Ceol</strong> is about to start playing sound on your device.
        </p>
        <p>
          Please make sure to <strong>set your device's volume </strong>accordingly.
        </p>
        <v-row>
          <v-col cols="12" id="">
            <v-btn id="startCtx" color="info" @click="tutoInfo = false;" block>Got it!</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>
  
</template>

<script>
 import * as Tone from "tone";
export default {

  name: 'CtxManager',
  components: {
  },
  data: function () {
    return {
      show: true,
    }
  },
  mounted() {
    if (!this.ctx) {
      document.getElementById('startCtx').addEventListener('click', async () => {
        await Tone.start()
        this.ctx = Tone.getContext()
      })
    }
  },
  methods: {
  },
  props: {
  },
  computed: {
    ctx: {
      get() {
        return this.$store.state.tune.ctx;
      },
      set(val) {
        return this.$store.commit('tune/setCtx', val)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
